/*eslint sort-keys: ["error", "asc", { natural: false, caseSensitive: true, minKeys: 2 }]*/
import {
  AAPReportsApiFactory,
  ActionOrientedProgramsApiFactory,
  AdverseImpactDataVisualizationsApiFactory,
  ApplicantFlowDataVisualizationsApiFactory,
  CompensationApiFactory,
  ComplianceChecklistApiFactory,
  DataVisualizationsApiFactory,
  DocumentCenterApiFactory,
  GoalDataVisualizationsApiFactory,
  GoodFaithEffortsApiFactory,
  IWDDataVisualizationsApiFactory,
  NotificationsApiFactory,
  OverviewDataVisualizationsApiFactory,
  OverviewSummaryApiFactory,
  PersonnelActivityDataVisualizationsApiFactory,
  PlanSummaryApiFactory,
  PlansApiFactory,
  ProtectedVeteranDataVisualizationsApiFactory,
  ReportSettingsApiFactory,
  ResourceLibraryApiFactory,
  ServiceDeliverablesApiFactory,
  ServiceLinesApiFactory,
  SystemAlertsApiFactory,
} from 'client'
import {
  AuthApiFactory,
  ClientManagementApiFactory,
  RequestSupportApiFactory,
  RoutingApiFactory,
  SSOApiFactory,
  SupportAccessApiFactory,
  UserContextApiFactory,
  UserManagementApiFactory,
  UsersApiFactory,
  VerifyApiFactory,
  ViewAsUserApiFactory,
} from 'client/identity'
import {
  UsersApiFactory as workforceAnalyticsUsersApiFactory,
  DataVisualizationsApiFactory as WorkforceAnalyticsDataVisualizationsApiFactory,
  ProjectApiFactory as WorkforceAnalyticsProjectApiFactory,
  ReportsApiFactory as WorkforceAnalyticsReportsApiFactory,
  SummariesApiFactory as WorkforceAnalyticsSummariesApiFactory,
  AnalysisApiFactory as WorkforceAnalyticsAnalysisApiFactory,
} from 'client/sratool'
import { fileInstance } from '~/api/instance'
import { getApiEndpoint } from '~/helpers/api'

export const api = {
  aapReports: AAPReportsApiFactory(undefined, getApiEndpoint()),
  aapReportsFile: AAPReportsApiFactory(
    undefined,
    getApiEndpoint(),
    fileInstance
  ),
  actionOrientedPrograms: ActionOrientedProgramsApiFactory(
    undefined,
    getApiEndpoint()
  ),
  adverseImpact: AdverseImpactDataVisualizationsApiFactory(
    undefined,
    getApiEndpoint()
  ),
  applicantFlow: ApplicantFlowDataVisualizationsApiFactory(
    undefined,
    getApiEndpoint()
  ),
  auth: AuthApiFactory(undefined, getApiEndpoint(window.__env?.IDENTITY_PORT)),
  clientManagement: ClientManagementApiFactory(
    undefined,
    getApiEndpoint(window.__env?.IDENTITY_PORT)
  ),
  compensation: CompensationApiFactory(undefined, getApiEndpoint()),
  complianceChecklist: ComplianceChecklistApiFactory(
    undefined,
    getApiEndpoint()
  ),
  dataVisualizations: DataVisualizationsApiFactory(undefined, getApiEndpoint()),
  documentCenter: DocumentCenterApiFactory(undefined, getApiEndpoint()),
  documentCenterFile: DocumentCenterApiFactory(
    undefined,
    getApiEndpoint(),
    fileInstance
  ),
  goal: GoalDataVisualizationsApiFactory(undefined, getApiEndpoint()),
  goodFaithEfforts: GoodFaithEffortsApiFactory(undefined, getApiEndpoint()),
  goodFaithEffortsFile: GoodFaithEffortsApiFactory(
    undefined,
    getApiEndpoint(),
    fileInstance
  ),
  iwd: IWDDataVisualizationsApiFactory(undefined, getApiEndpoint()),
  notifications: NotificationsApiFactory(undefined, getApiEndpoint()),
  overview: OverviewDataVisualizationsApiFactory(undefined, getApiEndpoint()),
  overviewSummary: OverviewSummaryApiFactory(undefined, getApiEndpoint()),
  personnelActivity: PersonnelActivityDataVisualizationsApiFactory(
    undefined,
    getApiEndpoint()
  ),
  planSummary: PlanSummaryApiFactory(undefined, getApiEndpoint()),
  plans: PlansApiFactory(undefined, getApiEndpoint()),
  protectedVeteran: ProtectedVeteranDataVisualizationsApiFactory(
    undefined,
    getApiEndpoint()
  ),
  reportSettings: ReportSettingsApiFactory(undefined, getApiEndpoint()),
  requestSupport: RequestSupportApiFactory(
    undefined,
    getApiEndpoint(window.__env?.IDENTITY_PORT)
  ),
  resourceLibrary: ResourceLibraryApiFactory(undefined, getApiEndpoint()),
  resourceLibraryFile: ResourceLibraryApiFactory(
    undefined,
    getApiEndpoint(),
    fileInstance
  ),
  routing: RoutingApiFactory(
    undefined,
    getApiEndpoint(window.__env?.IDENTITY_PORT)
  ),
  serviceDeliverables: ServiceDeliverablesApiFactory(
    undefined,
    getApiEndpoint()
  ),
  serviceDeliverablesFile: ServiceDeliverablesApiFactory(
    undefined,
    getApiEndpoint(),
    fileInstance
  ),
  serviceLines: ServiceLinesApiFactory(undefined, getApiEndpoint()),

  sso: SSOApiFactory(undefined, getApiEndpoint(window.__env?.IDENTITY_PORT)),
  ssoFile: SSOApiFactory(
    undefined,
    getApiEndpoint(window.__env?.IDENTITY_PORT),
    fileInstance
  ),
  supportAccess: SupportAccessApiFactory(
    undefined,
    getApiEndpoint(window.__env?.IDENTITY_PORT)
  ),
  systemAlerts: SystemAlertsApiFactory(undefined, getApiEndpoint()),
  userContext: UserContextApiFactory(
    undefined,
    getApiEndpoint(window.__env?.IDENTITY_PORT)
  ),
  userManagement: UserManagementApiFactory(
    undefined,
    getApiEndpoint(window.__env?.IDENTITY_PORT)
  ),
  userManagementFile: UserManagementApiFactory(
    undefined,
    getApiEndpoint(window.__env?.IDENTITY_PORT),
    fileInstance
  ),
  users: UsersApiFactory(
    undefined,
    getApiEndpoint(window.__env?.IDENTITY_PORT)
  ),
  usersFile: UsersApiFactory(
    undefined,
    getApiEndpoint(window.__env?.IDENTITY_PORT),
    fileInstance
  ),
  verify: VerifyApiFactory(
    undefined,
    getApiEndpoint(window.__env?.IDENTITY_PORT)
  ),
  viewAsUser: ViewAsUserApiFactory(
    undefined,
    getApiEndpoint(window.__env?.IDENTITY_PORT)
  ),

  // WORKFORCE ANALYTICS
  workforceAnalyticsAnalysesFile: WorkforceAnalyticsAnalysisApiFactory(
    undefined,
    getApiEndpoint(window.__env?.WFA_PORT),
    fileInstance
  ),
  workforceAnalyticsDataVisualizations:
    WorkforceAnalyticsDataVisualizationsApiFactory(
      undefined,
      getApiEndpoint(window.__env?.WFA_PORT)
    ),
  workforceAnalyticsProjects: WorkforceAnalyticsProjectApiFactory(
    undefined,
    getApiEndpoint(window.__env?.WFA_PORT)
  ),
  workforceAnalyticsReports: WorkforceAnalyticsReportsApiFactory(
    undefined,
    getApiEndpoint(window.__env?.WFA_PORT)
  ),
  workforceAnalyticsReportsFile: WorkforceAnalyticsReportsApiFactory(
    undefined,
    getApiEndpoint(window.__env?.WFA_PORT),
    fileInstance
  ),
  workforceAnalyticsSummaries: WorkforceAnalyticsSummariesApiFactory(
    undefined,
    getApiEndpoint(window.__env?.WFA_PORT)
  ),
  workforceAnalyticsSummariesFile: WorkforceAnalyticsSummariesApiFactory(
    undefined,
    getApiEndpoint(window.__env?.WFA_PORT),
    fileInstance
  ),
  workforceAnalyticsUsers: workforceAnalyticsUsersApiFactory(
    undefined,
    getApiEndpoint(window.__env?.WFA_PORT)
  ),
}
